<template>
  <div >
    <div style="background: #fff;">
      <div class="div-tabs">
        <span :class="activeTabs==='first'?'is-tabs':''" @click="clickTabs('first')">外呼数据统计</span>
        <span :class="activeTabs==='second'?'is-tabs':''" @click="clickTabs('second')">座席数据统计</span>
      </div>
    </div>
    <div v-if="activeTabs==='first'" style="padding: 15px;">
      <el-row class="row-top" :gutter="24">
        <el-col :span="6">
          <div>
            <h5 style="color:#374FB8;">{{ headData.totalCall.todayData }}</h5>
            <p class="mb-15">今日拨打数</p>
            <div class="div-bor-t">
              <em><i>总拨打数：</i><b>{{ headData.totalCall.totalData }}</b></em><br>
              <em><i>较昨日：</i><span :class="headData.totalCall.contrastYesterday<0?'f-green':'f-red'">
                {{ headData.totalCall.contrastYesterday }}<img v-if="headData.totalCall.contrastYesterday>0" src="@/assets/call/icon-up.png" alt=""><img v-else-if="headData.totalCall.contrastYesterday<0" src="@/assets/call/icon-down.png" alt="">
                </span>
              </em>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <h5 style="color:#23BDCC;">{{ headData.totalConnect.todayData }}</h5>
            <p>今日接通数</p>
            <div class="div-bor-t">
              <em><i>总接通数：</i><b>{{ headData.totalConnect.totalData }}</b></em><br>
              <em><i>较昨日：</i><span :class="headData.totalConnect.contrastYesterday<0?'f-green':'f-red'">
                {{ headData.totalConnect.contrastYesterday }}<img v-if="headData.totalConnect.contrastYesterday>0" src="@/assets/call/icon-up.png" alt=""><img v-else-if="headData.totalConnect.contrastYesterday<0" src="@/assets/call/icon-down.png" alt=""></span>
              </em>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <h5 style="color:#FF414F;">{{ headData.totalUnconnect.todayData }}</h5>
            <p>今日未接通数</p>
            <div class="div-bor-t">
              <em><i>总未接通数：</i><b>{{ headData.totalUnconnect.totalData }}</b></em><br>
              <em><i>较昨日：</i><span :class="headData.totalUnconnect.contrastYesterday<0?'f-green':'f-red'">
                  {{ headData.totalUnconnect.contrastYesterday }}<img v-if="headData.totalUnconnect.contrastYesterday>0" src="@/assets/call/icon-up.png" alt=""><img v-else-if="headData.totalUnconnect.contrastYesterday<0" src="@/assets/call/icon-down.png" alt="">
                </span>
              </em>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <h5 style="color:#FFB85A;">{{ headData.connectRatio.todayData }}%</h5>
            <p>接通率</p>
            <div class="div-bor-t">
              <em><i>总接通率：</i><b>{{ headData.connectRatio.totalData }}%</b></em><br>
              <em><i>较昨日：</i><span :class="headData.connectRatio.contrastYesterday<0?'f-green':'f-red'">
                  {{ headData.connectRatio.contrastYesterday }}%<img v-if="headData.connectRatio.contrastYesterday>0" src="@/assets/call/icon-up.png" alt=""><img v-else-if="headData.connectRatio.contrastYesterday<0" src="@/assets/call/icon-down.png" alt="">
                </span>
              </em>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <h5 style="color:#374FB8;">{{ headData.totalDuration.todayData }}</h5>
            <p>今日通话时长</p>
            <div class="div-bor-t">
              <em><i>总通话时长：</i><b>{{ headData.totalDuration.totalData }}</b></em><br>
              <em><i>较昨日：</i><span :class="headData.totalDuration.contrastYesterday<0?'f-green':'f-red'">
                  {{ headData.totalDuration.contrastYesterday }}%<img v-if="headData.totalDuration.contrastYesterday>0" src="@/assets/call/icon-up.png" alt=""><img v-else-if="headData.totalDuration.contrastYesterday<0" src="@/assets/call/icon-down.png" alt="">
                </span>
              </em>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="div-body">
        <p class="p-title">
          接通趋势分析
          <span class="fr radio-picker">
            <el-radio-group v-model="dateTrend.defaultTime" size="small" @change="changeRadio(1)">
              <el-radio-button label="3">近7天</el-radio-button>
              <el-radio-button label="4">近30天</el-radio-button>
              <el-radio-button label="5">近90天</el-radio-button>
            </el-radio-group>
            <el-date-picker :clearable="false" :class="dateTrend.date.length?'is-active':''" @change="changeDate(1)" size="small" style="width:250px;" v-model="dateTrend.date" value-format="yyyy-MM-dd"
              type="daterange" range-separator="一" popper-class="popper-picker" start-placeholder="开始日期" end-placeholder="结束日期" />
          </span>
        </p>
        <div id="myChart1" style="width: 100%;height:350px;"></div>
      </div>
      <div class="div-body">
        <p class="p-title">
          接通时段趋势分析
          <span class="fr radio-picker">
            <el-radio-group v-model="timeTrend.defaultTime" size="small" @change="changeRadio(2)">
              <el-radio-button label="3">近7天</el-radio-button>
              <el-radio-button label="4">近30天</el-radio-button>
              <el-radio-button label="5">近90天</el-radio-button>
            </el-radio-group>
            <el-date-picker :clearable="false" :class="timeTrend.date.length?'is-active':''" @change="changeDate(2)" size="small" style="width:250px;" v-model="timeTrend.date" type="daterange" value-format="yyyy-MM-dd"
              range-separator="一" popper-class="popper-picker" start-placeholder="开始日期" end-placeholder="结束日期" />
          </span>
        </p>
        <div id="myChart2" style="width: 100%;height:350px;"></div>
      </div>
      <div class="div-body">
        <p class="p-title">
          地区接通分析
          <span class="fr radio-picker">
            <el-radio-group v-model="areaTrend.defaultTime" size="small" @change="changeRadio(3)">
              <el-radio-button label="3">近7天</el-radio-button>
              <el-radio-button label="4">近30天</el-radio-button>
              <el-radio-button label="5">近90天</el-radio-button>
            </el-radio-group>
            <el-date-picker :clearable="false" :class="areaTrend.date.length?'is-active':''" @change="changeDate(3)" size="small" style="width:250px;" v-model="areaTrend.date" type="daterange" value-format="yyyy-MM-dd"
              range-separator="一" popper-class="popper-picker" start-placeholder="开始日期" end-placeholder="结束日期" />
          </span>
        </p>
        <div id="myChart3" style="width: 100%;height:350px;"></div>
      </div>
      <div class="div-table">
        <p class="p-title">呼叫明细
          <span class="fr radio-picker">
            <el-radio-group v-model="callDetail.callTime" size="small" @change="changeRadio(4)">
              <el-radio-button label="3">近7天</el-radio-button>
              <el-radio-button label="4">近30天</el-radio-button>
              <el-radio-button label="5">近90天</el-radio-button>
            </el-radio-group>
            <el-date-picker  :clearable="false" :class="callDetail.date.length?'is-active':''" @change="changeDate(4)" size="small" style="width:250px;" v-model="callDetail.date" value-format="yyyy-MM-dd" type="daterange" range-separator="一"
              popper-class="popper-picker" start-placeholder="开始日期" end-placeholder="结束日期" />
            <el-button size="mini" type="primary" @click="exportCallDetail">导出</el-button>
          </span>
        </p>
        <el-table :data="tableData" @selection-change="handleSelectionChange" :header-cell-style="{color:'#333'}">
          <el-table-column align="center" type="selection" width="80"></el-table-column>
          <el-table-column prop="callDate" label="日期" ></el-table-column>
          <el-table-column prop="callCount" label="全部呼叫"></el-table-column>
          <el-table-column prop="successCallCount" label="接通数"></el-table-column>
          <el-table-column prop="failCallCount" label="未接通数"></el-table-column>
          <el-table-column prop="successCallRate" label="接通率"></el-table-column>
          <el-table-column prop="totalCallTime" label="通话时长"></el-table-column>
          <el-table-column prop="averageCallTime" label="平均通话时长"></el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="clickDetail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination :page-num="pageNum" :page-size="pageSize" :total="total" @sizeChange="handleSizeChange" @currentChange="handleCurrentChange" style="margin-top:60px;" />
      </div>
    </div>
    <div v-if="activeTabs==='second'">
      <seats />
    </div>
  </div>
</template>
<script>
import pagination from '@/components/pagination'
import { debounce } from '@/base/global'
import * as echarts from 'echarts'
import seats from './seats'
import { getTodayAggregate, getDateTrend, getTimeTrend, getAreaTrend, getCallDetail, exportCallDetail } from '../api'
import '@/assets/text/text.css'

export default {
  components: {
    seats, pagination
  },
  data () {
    return {
      activeTabs: 'first',
      pageNum: 1,
      pageSize: 20,
      total: 0,
      headData: {
        totalCall: {
          todayData: 0,
          totalData: 0,
          contrastYesterday: 0
        },
        totalConnect: {
          todayData: 0,
          totalData: 0,
          contrastYesterday: 0
        },
        totalUnconnect: {
          todayData: 0,
          totalData: 0,
          contrastYesterday: 0
        },
        connectRatio: {
          todayData: 0,
          totalData: 0,
          contrastYesterday: 0
        },
        totalDuration: {
          todayData: 0,
          totalData: 0,
          contrastYesterday: 0
        }
      },
      tableData: [],
      exportDates: [],
      myChart1: null,
      myChart2: null,
      myChart3: null,
      date4: [],
      areaTrend: {
        defaultTime: '3',
        date: [],
        endTime: '',
        startTime: ''
      },
      timeTrend: {
        defaultTime: '3',
        date: [],
        endTime: '',
        startTime: ''
      },
      dateTrend: {
        defaultTime: '3',
        date: [],
        endTime: '',
        startTime: ''
      },
      callDetail: {
        callTime: '3',
        date: [],
        callEndDate: '',
        callBeginDate: ''
      }
    }
  },
  beforeDestroy () {
    this.getPageWrapPadding()
  },
  mounted () {
    this.setPageWrapPadding()
    this.getTodayAggregate()
    this.getDateTrend()
    this.getTimeTrend()
    this.getAreaTrend()
    this.getCallDetail()
    setTimeout(() => {
      this.addResizeEvent(this.newResize)
    }, 1000)
  },
  methods: {
    clickTabs (val) {
      this.activeTabs = val
      if (this.activeTabs === 'first') {
        this.getTodayAggregate()
        this.getDateTrend()
        this.getTimeTrend()
        this.getAreaTrend()
        this.getCallDetail()
        setTimeout(() => {
          this.addResizeEvent(this.newResize)
        }, 1000)
      }
    },
    clickDetail (row) {
      this.$router.push({ path: '/zxk/reach/call/outboundDetails', query: { callDate: row.callDate } })
    },
    exportCallDetail () {
      if (!this.tableData.length) {
        this.$message.warning('暂无可导出数据')
        return false
      }
      var data = {}
      if (this.exportDates.length) {
        data.exportDates = this.exportDates
      } else {
        data = {
          exportDates: null,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.callDetail
        }
      }
      exportCallDetail(data).then(res => {
        this.Global.downloadBlob(res.data, '呼叫明细.xlsx')
      })
    },
    getCallDetail () {
      var data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...this.callDetail
      }
      getCallDetail(data).then(res => {
        this.tableData = this.Global.transformEmptyObject(res.data.list)
        this.total = Number(res.data.total)
      })
    },
    handleSizeChange (val) {
      this.pageNum = 1
      this.pageSize = val
      this.getCallDetail()
    },
    handleCurrentChange (i) {
      this.pageNum = i
      this.getCallDetail()
    },
    changeRadio (sign) {
      if (sign === 1) {
        this.dateTrend.date = []
        this.dateTrend.startTime = ''
        this.dateTrend.endTime = ''
        this.getDateTrend()
      } else if (sign === 2) {
        this.timeTrend.date = []
        this.timeTrend.startTime = ''
        this.timeTrend.endTime = ''
        this.getTimeTrend()
      } else if (sign === 3) {
        this.areaTrend.date = []
        this.areaTrend.startTime = ''
        this.areaTrend.endTime = ''
        this.getAreaTrend()
      } else {
        this.callDetail.date = []
        this.callDetail.callBeginDate = ''
        this.callDetail.callEndDate = ''
        this.getCallDetail()
      }
    },
    changeDate (sign) {
      if (sign === 1) {
        this.dateTrend.defaultTime = ''
        this.dateTrend.startTime = this.dateTrend.date[0] ? this.dateTrend.date[0] : ''
        this.dateTrend.endTime = this.dateTrend.date[1] ? this.dateTrend.date[1] : ''
        this.getDateTrend()
      } else if (sign === 2) {
        this.timeTrend.defaultTime = ''
        this.timeTrend.startTime = this.timeTrend.date[0] ? this.timeTrend.date[0] : ''
        this.timeTrend.endTime = this.timeTrend.date[1] ? this.timeTrend.date[1] : ''
        this.getTimeTrend()
      } else if (sign === 3) {
        this.areaTrend.defaultTime = ''
        this.areaTrend.startTime = this.areaTrend.date[0] ? this.areaTrend.date[0] : ''
        this.areaTrend.endTime = this.areaTrend.date[1] ? this.areaTrend.date[1] : ''
        this.getAreaTrend()
      } else {
        this.callDetail.callTime = ''
        this.callDetail.callBeginDate = this.callDetail.date[0] ? this.callDetail.date[0] : ''
        this.callDetail.callEndDate = this.callDetail.date[1] ? this.callDetail.date[1] : ''
        this.getCallDetail()
      }
    },
    getEcharts3 (xAxisData, seriesData1, seriesData2, seriesData3) {
      this.myChart3 = echarts.init(
        document.getElementById('myChart3')
      )
      var option = {
        tooltip: {
          confine: true,
          // appendToBody: true,
          trigger: 'axis',
          backgroundColor: 'rgba(3,3,3,0.6)',
          extraCssText: 'box-shadow: 0px 1px 4px 0px #B1B1B1;',
          textStyle: {
            color: '#fff' // 设置文字颜色
          },
          axisPointer: {
            type: 'shadow'
          },
          formatter: function (a) {
            var res = ''
            var sum = 0
            a.forEach(e => {
              if (e.seriesName !== '接通率') {
                sum += e.value
              }
            })
            a.forEach((item, index) => {
              if (index == 0) {
                res += `${item.axisValue} 总数：${sum}<br/>`
              }

              res += `${item.marker} ${item.seriesName}：${item.value} ` + (item.seriesName === '接通率' ? '%' : '') + '<br/>'
            })
            return res
          }
        },

        legend: {
          data: ['接通数', '未接通数', '接通率'],
          bottom: 'bottom'
        },
        grid: {
          left: '50px',
          right: '50px',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: xAxisData,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            },
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          },
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            },
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        ],
        color: ['#81C6FF', '#4A95FF', '#FFB85A'],
        series: [
          {
            name: '接通数',
            type: 'bar',
            stack: '搜索引擎',
            emphasis: {
              focus: 'series'
            },
            data: seriesData1
          },
          {
            name: '未接通数',
            type: 'bar',
            stack: '搜索引擎',
            emphasis: {
              focus: 'series'
            },
            data: seriesData2
          },
          {
            name: '接通率',
            type: 'line',
            label: {
              show: true,
              position: 'top'
            },
            yAxisIndex: 1,
            smooth: true,
            data: seriesData3
          }
        ]
      }
      this.myChart3.clear()
      this.myChart3.resize()
      this.myChart3.setOption(option)
    },
    getAreaTrend () {
      getAreaTrend(this.areaTrend).then(res => {
        var xAxisData = res.data.map(x => x.area)
        var seriesData1 = res.data.map(x => x.connect)
        var seriesData2 = res.data.map(x => x.unconnected)
        var seriesData3 = res.data.map(x => x.connectRatio)
        setTimeout(() => {
          this.getEcharts3(xAxisData, seriesData1, seriesData2, seriesData3)
        }, 100)
      })
    },
    getEcharts2 (xAxisData, seriesData1, seriesData2) {
      this.myChart2 = echarts.init(
        document.getElementById('myChart2')
      )
      var option = {
        xAxis: {
          boundaryGap: false,
          type: 'category',
          nameLocation: 'middle',
          data: xAxisData,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        legend: {
          bottom: '10',
          data: ['接通数', '未接通数']
        },
        grid: {
          top: '10%',
          left: '50px',
          right: '50px',
          bottom: '20%'
        },
        tooltip: {
          confine: true,
          // appendToBody: true,
          trigger: 'axis',
          backgroundColor: 'rgba(3,3,3,0.6)',
          extraCssText: 'box-shadow: 0px 1px 4px 0px #B1B1B1;',
          textStyle: {
            color: '#fff' // 设置文字颜色
          },
          axisPointer: {
            // type: 'shadow'
          }
        },
        color: ['#14E248', '#12B2FA'],
        series: [
          {
            type: 'line',
            name: '接通数',
            showSymbol: false,
            smooth: true,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(20, 226, 72, 0.2)'
              }, {
                offset: 1,
                color: 'rgba(20, 226, 72, 0)'
              }])
            },
            data: seriesData1
          },
          {
            name: '未接通数',
            type: 'line',
            showSymbol: false,
            smooth: true,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(18,178,250, 0.2)'
              }, {
                offset: 1,
                color: 'rgba(18,178,250, 0)'
              }])
            },
            data: seriesData2
          }
        ]
      }
      this.myChart2.clear()
      this.myChart2.resize()
      this.myChart2.setOption(option)
    },
    getTimeTrend () {
      getTimeTrend(this.timeTrend).then(res => {
        var xAxisData = res.data.map(x => x.dataOrTime)
        var seriesData1 = res.data.map(x => x.connect)
        var seriesData2 = res.data.map(x => x.unconnected)
        setTimeout(() => {
          this.getEcharts2(xAxisData, seriesData1, seriesData2)
        }, 100)
      })
    },
    getEcharts1 (xAxisData, seriesData1, seriesData2) {
      this.myChart1 = echarts.init(
        document.getElementById('myChart1')
      )
      var option = {
        xAxis: {
          boundaryGap: false,
          type: 'category',
          nameLocation: 'middle',
          data: xAxisData,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        legend: {
          bottom: '10',
          data: ['接通数', '未接通数']
        },
        grid: {
          top: '10%',
          left: '50px',
          right: '50px',
          bottom: '20%'
        },
        tooltip: {
          confine: true,
          // appendToBody: true,
          trigger: 'axis',
          backgroundColor: 'rgba(3,3,3,0.6)',
          extraCssText: 'box-shadow: 0px 1px 4px 0px #B1B1B1;',
          textStyle: {
            color: '#fff' // 设置文字颜色
          },
          axisPointer: {
            // type: 'shadow'
          }
        },
        color: ['#23BDCC', '#FF414F'],
        series: [
          {
            type: 'line',
            name: '接通数',
            showSymbol: false,
            smooth: false,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(35, 189, 204, 0.2)'
              }, {
                offset: 1,
                color: 'rgba(35, 189, 204, 0)'
              }])
            },
            data: seriesData1
          },
          {
            name: '未接通数',
            type: 'line',
            showSymbol: false,
            smooth: false,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(255, 65, 79, 0.2)'
              }, {
                offset: 1,
                color: 'rgba(255, 65, 79, 0)'
              }])
            },
            data: seriesData2
          }
        ]
      }
      this.myChart1.clear()
      this.myChart1.resize()
      this.myChart1.setOption(option)
    },
    getDateTrend () {
      getDateTrend(this.dateTrend).then(res => {
        var xAxisData = res.data.map(x => x.dataOrTime)
        var seriesData1 = res.data.map(x => x.connect)
        var seriesData2 = res.data.map(x => x.unconnected)
        setTimeout(() => {
          this.getEcharts1(xAxisData, seriesData1, seriesData2)
        }, 100)
      })
    },
    getTodayAggregate () {
      getTodayAggregate({}).then(res => {
        this.headData = res.data
      })
    },
    newResize () {
      this.antiShake()
    },
    addResizeEvent (func) {
      var oldResize = window.onresize
      window.onresize = function () {
        func()
        if (typeof oldResize === 'function') {
          oldResize()
        }
      }
    },
    antiShake: debounce(function (e) {
      this.myChart1.resize()
      this.myChart2.resize()
      this.myChart3.resize()
    }, 500),
    handleSelectionChange (val) {
      this.exportDates = val.map(x => x.callDate)
    }
  }
}
</script>
<style lang="scss">
.div-tabs{
  height: 45px;
  line-height: 45px;
  border-bottom: 1px solid #F2F2F2;
  .is-tabs{
    color: #4F7AFD;
    border-bottom: 2px solid #4F7AFD;
  }
  span{
    display: inline-block;
    width: 120px;
    text-align: center;
    height: 100%;
    cursor: pointer;
    height: calc(100% + 1px);
    position: relative;
    top: 1px;
  }
}
.popper-picker {
  .el-date-table td.today span {
    border-radius: 2px;
    border: 1px solid #374fb8;
    color: #374fb8;
  }
  .el-date-table td.end-date span,
  .el-date-table td.start-date span {
    background: #374fb8;
    border-radius: 2px;
    color: #fff;
  }
}
</style>
<style lang="scss" scoped>
.radio-picker {
  .el-radio-group {
    /deep/ .is-active {
      .el-radio-button__inner {
        background: #374fb8;
        border-color: #374fb8;
        box-shadow: -1px 0 0 0 #374fb8;
      }
    }
    /deep/ .el-radio-button:last-child .el-radio-button__inner {
      border-radius: 0px;
    }
  }
  .el-date-editor.is-active {
    background: #374fb8;
    border-color: #374fb8;
    /deep/ .el-range-input {
      background: #374fb8;
      color: #fff;
    }
    /deep/ .el-range-separator {
      color: #fff;
    }
  }
  .el-date-editor {
    position: relative;
    left: -1px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }
  .el-button--primary {
    background: #374fb8;
    border-color: #374fb8;
    padding: 8.5px 28px;
    margin-left: 24px;
    position: relative !important;
    top: -6px !important;
  }
}

.f-red {
  color: #ff414f;
}
.f-green {
  color: #14e248;
}
.w-160 {
  width: 160px;
}
.a-btn {
  display: inline-block;
  width: 66px;
  height: 32px;
  border: 1px solid #e4e6e8;
  border-radius: 4px;
  line-height: 32px;
  text-align: center;
  color: #666;
  font-size: 12px;
}
.row-top {
  *{
    font-family: 'PTRootUI-Medium, PTRootUI';
  }
  .el-col-6 {
    max-width: 20%;
  }
  .el-col-6 > div {
    height: 166px;
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(37, 53, 138, 0.1);
    text-align: center;
    h5 {
      font-size: 28px;
      font-weight: bold;
      padding-top: 20px;
      margin-bottom: 5px;
    }
    p {
      color: #999;
      margin-bottom: 18px;
    }
    .div-bor-t {
      border-top: 1px solid #e5e5e5;
      color: #999;
      // height: 48px;
      // line-height: 28px;
      em {
        display: inline-block;
        width: 100%;
        font-size: 14px;
        margin-top: 10px;
        i {
          display: inline-block;
          width: 85px;
          text-align: right;
        }
        b {
          color: #333;
        }
        img {
          position: relative;
          top: 3px;
        }
        b,
        span {
          display: inline-block;
          width: calc(100% - 100px);
          font-size: 16px;
          text-align: left;
        }
      }
    }
  }
}
.p-title {
  margin-top: 10px;
  margin-bottom: 20px;
  color: #333;
  font-weight: 600;
  border-left: 2px solid #374fb8;
  padding-left: 5px;
  .el-radio-group,
  .el-button {
    position: relative;
    top: -1px;
  }
  .el-date-editor {
    position: relative;
    // top: -3px;
  }
}
.div-body {
  margin-top: 24px;
  padding: 24px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(37, 53, 138, 0.1);
}
.div-table {
  margin-top: 24px;
  padding: 24px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(37, 53, 138, 0.1);
}
.div-screen {
  margin-bottom: 24px;
  padding: 24px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(37, 53, 138, 0.1);
  .div-row {
    height: 32px;
    line-height: 32px;
    position: relative;
    /deep/ .el-icon-close {
      right: -5px;
      top: -2px;
    }
  }
  .div-row + .div-row {
    margin-top: 12px;
  }
  .span-lable {
    display: inline-block;
    text-align: right;
    width: 60px;
    color: #666;
    font-size: 12px;
    margin-right: 8px;
  }
  .input-with-select /deep/ .el-input-group__append {
    width: 32px;
    background: #374fb8;
    padding: 0 10px;
    border-color: #374fb8;
  }
  .a-btn {
    position: relative;
    top: 1px;
    display: inline-block;
    width: 66px;
    height: 32px;
    border: 1px solid #e4e6e8;
    border-radius: 4px;
    line-height: 32px;
    text-align: center;
    color: #666;
    font-size: 12px;
    img {
      position: relative;
      top: 3px;
    }
  }
  .span-option {
    font-size: 12px;
    color: #666;
    cursor: pointer;
  }
  .span-option:hover {
    color: #374fb8;
    font-size: 14px;
  }
  .span-option + .span-option {
    margin-left: 32px;
  }
  .is-select {
    font-size: 14px;
    color: #374fb8;
  }
}
</style>
